/**
 * @file goods-request-cancel-request.tsx
 * @module app/modals/goods-request-cancel-request
 * @description Renders the goods request cancel request modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import Modal from 'react-bootstrap/Modal';
import { Button, Col, Row, Form } from 'react-bootstrap';
import { useState } from 'react';
import { CloseModalButton } from '../components';

const GoodCancelRequest = (props: any) => {
  const [note, setNote] = useState('');

  const handleSave = () => {
    if (props.onSave) {
      // pass note back to parent
      props.onSave(note);
    }
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-590px"
        className="border-r10px"
      >
        <Modal.Header>
          <Modal.Title>
            Are you sure you want to cancel {props.title}?
          </Modal.Title>
          <div className="text-end">
            <CloseModalButton onClick={props.onHide} />
          </div>
        </Modal.Header>

        <Modal.Body className="pt-5">
          {props.isRemove ? (
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="bg-light-danger text-center border-r10px p-3">
                  <span className="fs-18 fw-500">{props.removeMsg}</span>
                </div>
              </div>
            </div>
          ) : (
            <Form.Group controlId="cancelNote">
              <Form.Label className="fs-16 fw-600">note</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder={props.placeholder || 'Enter note for cancellation'}
                value={note}
                onChange={(e: any) => setNote(e.target.value)}
              />
            </Form.Group>
          )}
        </Modal.Body>

        <Modal.Footer className="pt-0 pb-8 mb-4 border-top-0">
          <Row className="align-items-center justify-content-center g-3 w-100">
            <Col xs="auto">
              <Button className="uw-btn uw-btn-danger uw-btn-lg" variant="danger" size="lg" onClick={handleSave}>
                {!props.loading && (
                  <span className="indicator-label fs-16 fw-bold">
                    {props.save ? props.save : 'Save'}
                  </span>
                )}
                {props.loading && (
                  <span
                    className="indicator-progress fs-16 fw-bold"
                    style={{ display: 'block' }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GoodCancelRequest;
